module.exports = __webpack_public_path__ + "images/industrial-4-ec5d77108a7f95ff89bce9b83043fc32.jpg";